import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { LicenseInfo } from "@mui/x-license-pro";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import store from "./app/store";
import theme from "./assets/Theme";
import ErrorBoundary from "./components/fundamentals/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { genericErrorCodeToErrorMessageMap } from "./util/errorMapper";

// See https://dev.to/ozanbolel/fit-your-website-to-the-viewport-on-mobile-38hl
const resizeOps = () => {
  document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01 + "px");
};
resizeOps();
window.addEventListener("resize", resizeOps);

LicenseInfo.setLicenseKey(process.env.REACT_APP_MAT_UI);

const history = createBrowserHistory();

let persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <HashRouter history={history}>
              <ErrorBoundary
                message={genericErrorCodeToErrorMessageMap.genericError.message}
                code={genericErrorCodeToErrorMessageMap.genericError.code}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <ScrollToTop />
                  <App />
                </LocalizationProvider>
              </ErrorBoundary>
            </HashRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
